module.exports = __webpack_public_path__ + "img/stock3.70ebf2e1.png";